import 'react-toastify/dist/ReactToastify.css';
import { Route, Switch, useRouteMatch } from 'react-router';
import { ToastContainer } from 'react-toastify';
import AddGame from './AddGame';
import AdminGamesList from './AdminGamesList';
import AdminPageWrapper from '../../../components/common/wrappers/AdminPageWrapper';
import EditGame from './EditGame';

export default function Admin() {
    const match = useRouteMatch();
    return (
        <AdminPageWrapper>
            <div className="admin-screen">
                <Switch>
                    <Route exact path={`${match.path}/games/new`} component={AddGame} />
                    <Route exact path={`${match.path}/games/:id/edit`} component={EditGame} />
                    <Route component={AdminGamesList} />
                </Switch>
                <ToastContainer />
            </div>
        </AdminPageWrapper>
    );
}
